module.exports = __webpack_public_path__ + "media/common/icon-weather-rainy-or-snowy-fcf70b56.svg";